import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { planEnrollmentService } from "./service";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;

export const withdrawCancellationPlanEnrollment = async (
  planEnrollmentId: string
): Promise<IPlanEnrollment> => {
  const { data } = await planEnrollmentService.post(
    `/${planEnrollmentId}/withdraw-cancellation`
  );
  return data;
};
